import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DAYS, parseShift } from 'src/app/shared/constants/constants';
import { FormsService } from 'src/app/shared/services/forms.service';

@Component({
  selector: 'app-commercial-agreements-details',
  templateUrl: './commercial-agreements-details.component.html',
  styleUrls: ['./commercial-agreements-details.component.css'],
})
export class CommercialAgreementsDetailsComponent implements OnInit {
  @Input() agreement?: any = {};
  @Input() isColapsed: boolean = false;
  days = DAYS;
  hasAgrement: boolean = false;
  form: FormGroup;

  constructor(private fb: FormBuilder, private formsService: FormsService) {
    this.form = this.fb.group({
      workShifts: this.fb.array([this.formsService.createWorkShift()]),
    });
  }

  ngOnInit(): void {
    if (this.agreement) {
      this.hasAgrement = true;
      this.populateWorkShifts(this.agreement.contractualShifts);
    }
  }

  get workShifts(): FormArray {
    return this.form.get('workShifts') as FormArray;
  }

  private populateWorkShifts(shiftStrings: any[]): void {
    const workShifts = this.workShifts;
    workShifts.clear();

    if (Array.isArray(shiftStrings)) {
      shiftStrings.forEach((shiftStr) => {
        const shift = parseShift(shiftStr);
        if (shift) {
          const shiftGroup = this.formsService.createShiftFormToView(shift);
          workShifts.push(shiftGroup);
        }
      });
    }
  }
}
